<template lang="html">
    <entity-page id="page__customer-group" v-bind:loading="progress">
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded @click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded @click="save"></z-icon-button>
        </template>

        <z-input 
            v-model="zone.name" id="name" name="name" v-validate="'required|min:3'"  v-bind:required="true" label="Направление"  
            v-bind:error="errors.first('name')" data-vv-name="name" v-bind:data-vv-as="' '" placeholder="Введите направление"
        ></z-input>

        <toggle-card v-if="zone.id && zone.id != 'new'" v-bind:visibility="true" v-bind:heading="'Населённые пункты'">
            <z-input-zone-cities v-bind:zone="zone" ref="cities"></z-input-zone-cities>
        </toggle-card>
    </entity-page>
</template>
<script>
    import ToggleCard   from '@/components/ToggleCard'
    import ZInputZoneCities from '@/components/ZInputZoneCities';
    import ZInput      from '@/components/ZInput';
    import ZIconButton from '@/components/ZIconButton';
    import EntityPage  from '@/components/EntityPage.vue';
    export default {
        components: {ZInputZoneCities, ToggleCard, ZInput, ZIconButton, EntityPage},
        data() {
            return {
                title: 'Направление',
                zone: {},
                zoneDefault: {
                    id: null,
                    name: null,
                    aoguid: null,
                    disid: null,
                    okato: null,
                    parentguid: null,
                    regioncode: null,
                    sort: 100
                }
            }
        },
        metaInfo() {
            return {
                title: this.title
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['load-zone-card'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
        },
        created() {
            this.init();
        },
        methods: {
            /**
             * Инициализация компонента
             */
            init() {
                this.$store.commit('setTitle', 'Направления');
                this.$store.commit('openRightPanel');
                if (!this.$route.params.zoneid || this.$route.params.zoneid == 'new') this.zone = Object.assign({}, this.zoneDefault);
                else this.getZone().then(r => {
                    if (r && r.id) this.zone = Object.assign({}, r);
                });
            },
            /**
             * Получение зоны
             */
            getZone() {
                this.$store.commit('showProgressBar', 'load-zone-card');
                return this.$store.dispatch('cost/getZone', { id: this.$route.params.zoneid })
                    .finally(() => this.$store.commit('hideProgressBar', 'load-zone-card'));
            },
            /**
             * Сохранение
             */
            save() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    if (this.$route.params.zoneid != 'new') this.putZone();
                    else this.postZone();
                });
            },
            /**
             * Добавление зоны
             */
            postZone() {
                this.$store.commit('showProgressBar', 'load-zone-card');
                this.$store.dispatch('cost/addZone', this.zone).then(r => {
                    if (!r) return;
                    this.$root.$emit('reload-table', 'zones');
                    this.$router.replace({name: 'Zone', params: {zoneid: r.id}});
                }).finally(() => this.$store.commit('hideProgressBar', 'load-zone-card'));
            },
            /**
             * Изменение зоны
             */
            putZone() {
                this.$store.commit('showProgressBar', 'load-zone-card');
                this.$store.dispatch('cost/updateZone', this.zone).then(r => {
                    if (!r) return;
                    this.init();
                    this.$root.$emit('reload-table', 'zones');
                }).finally(() => this.$store.commit('hideProgressBar', 'load-zone-card'));
            },
            /**
             * Возврат на предидущую страницу
             */
            back() {
                this.$router.push({name: 'Zones', query: this.$route.query});
            }
        },
        watch: {
            '$route.params.zoneid'() {
                this.init()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Zone.vue?4fe79bd4